import React, { useRef, useState } from 'react'
import { useFormik } from 'formik';
import Cookies from 'js-cookie';
import { toast } from 'react-toastify';
import * as Yup from 'yup';
// import { adminMainUrl } from '../../Config';
import Offcanvas from 'react-bootstrap/Offcanvas';
import { adminMainUrl } from "../../Config.jsx";
import axios from 'axios';
import { useDispatch } from 'react-redux';
import CustomerProfileDocumentationList from './CustomerProfileDocumentationList.jsx';
const DisapprovedDocUpload = ({ show, handleClose, onSuccess, id }) => {
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [filePreview, setFilePreview] = useState(null);
    const closeButtonRef = useRef(null);
    const dispatch = useDispatch();
    const validationSchema = Yup.object({
        image: Yup.string().required('Image is required'),
    });

    // Initialize Formik
    const formik = useFormik({
        initialValues: {
            document_id: '',
            image: '', // Initial value for the RequiredService type
        },
        validationSchema: validationSchema,

        onSubmit: async (values) => {
            setIsSubmitting(true)
            try {
                values.document_id = id
                let config = { headers: { "auth-token": Cookies.get('customertoken'), 'content-type': 'multipart/form-data', } }


                axios.post(`${adminMainUrl}/api/customer-profile/upload-disapproved-documents-again`, values, config)
                    .then(res => {
                        if (res.status === 200) {


                            toast.success(res.data.msg);
                            setIsSubmitting(false);
                            handleClose();
                            dispatch(CustomerProfileDocumentationList())
                        } else {
                            toast.error(res.data.msg);
                            setIsSubmitting(false);
                        }
                    }).catch(err => {
                        console.log(err);
                        if (err.response) {
                            toast.error(err.response.data.msg);
                        } else {
                            toast.error("Internal server error.")
                        }
                        setIsSubmitting(false);
                    });
            } catch (error) {
                console.log(error);
                toast.error(error.response.data.msg);
                setIsSubmitting(false);
            }
        },
    });

    const handleFileChange = (e) => {
        const file = e.target.files[0]; // Get the first file
        if (file) {
            formik.setFieldValue('image', file); // Update formik field value
            setFilePreview(URL.createObjectURL(file)); // Set the preview URL
        }
    };

    return (
        <Offcanvas className="custom-offcanvas" show={show} onHide={handleClose} placement="end">
            <Offcanvas.Header closeButton>
                <Offcanvas.Title>Upload Document</Offcanvas.Title>
            </Offcanvas.Header>
            <Offcanvas.Body>
                <form onSubmit={formik.handleSubmit}>
                    <div className="col-md-12">
                        <div className="mb-3">
                            <label htmlFor="basicpill-firstname-input" className="form-label">
                                Upload Document<span className="text-danger">*</span>
                            </label>
                            <div className="custom-file-container">
                                <label className="custom-file-container__custom-file">
                                    <i className="fa-solid fa-upload"></i> Upload Files
                                    <input
                                        type="file"
                                        className="custom-file-container__custom-file__custom-file-input d-none"
                                        name='image'
                                        accept="image/*" // Ensure only image files are selected
                                        onChange={handleFileChange}
                                        onBlur={formik.handleBlur}
                                    />
                                    <span className="custom-file-container__custom-file__custom-file-control"></span>
                                </label>
                            </div>
                            <div className="help-block with-errors">
                                {formik.errors.image ? (
                                    <div className="text-danger small">{formik.errors.image}</div>
                                ) : null}
                            </div>

                            {/* Image preview section */}
                            {filePreview && (
                                <div className="image-preview mt-2">
                                    <img src={filePreview} alt="Preview" className="img-thumbnail" style={{ width: '200px', height: 'auto' }} />
                                </div>
                            )}
                        </div>
                    </div>
                    <div className="d-flex justify-content-end">
                        <button className="btn btn-primary text-xs" type="submit" disabled={isSubmitting}>
                            {isSubmitting ? <i className="fa fa-spinner fa-spin" /> : "Submit"}
                        </button>
                    </div>

                </form>
            </Offcanvas.Body>
        </Offcanvas>
    )
}

export default DisapprovedDocUpload